module.exports = __webpack_public_path__ + "img/Service.b45c66e2.gif";